import React, { useState, useEffect, forwardRef } from "react";
import { instance } from "../../axios";
import { TableZero, PageHeader, UiButton, OverlayLoader, UiDatePicker, BgLoader, InLoader, UiClientSelect, UiActionDropDown, UiInput, UiSelect, Avatar, PageError, Toastcontent } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useQuery, useQueryClient, select } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import jsPDF from 'jspdf';
import { getStorage, setStorage, updateFilterUrl } from "../../helper.js";
import autoTable from 'jspdf-autotable';
import { toast } from "react-toastify";
import generatePDF from '../../bulk_pdf.js';

export default function Ledger() {
  const [fy] = useOutletContext();
  let navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient()
  const zstate = useStore((state) => state);
  const setZState = useStore((state) => state.setClients);
  const [pagenum, setPage] = useState(1);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [tableDisable, setTableDisable] = useState(false);
  const parsed = queryString.parse(location.search);
  const [loader, showLoader] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);


  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: getStorage('perpage') ? [20, 50, 100].includes(parseInt(getStorage('perpage'))) ? parseInt(getStorage('perpage')) : 20 : 20,
      showSizeChanger: true,
      pageSizeOptions: [20, 50, 100],
    },

  });


  const schema = yup.object().shape(
    {

    }
  );


  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    control,
    formState,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });


  const onSubmitHandler = async (data) => {

    setSelectedRowKeys([])
    setPage(1)
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
    });
    const obj = {};
    Object.entries(data).map(([key, val]) => {
      if (val) {
        obj[key] = Array.isArray(val) ? (val.map(itm => itm.value)).join(',') : val.label ? val.value : val
      }
    })


    navigate(updateFilterUrl(obj, 'ledger', 1), { replace: location.search ? true : false })


  };




  const headers = [
    { label: "Date", key: "date" },
    { label: "No.", key: "num" },
    { label: "Particulars", key: "account" },
    { label: "Type", key: "type" },
    { label: "Debit", key: "debit" },
    { label: "Credit", key: "credit" },
    { label: "Balance", key: "balance" },


  ];

  const [filter, setFilter] = useState({});



  async function fetchData(filter) {

    let currentUrlParams = new URLSearchParams(filter);

    const { data } = await instance.get(
      "/ledger?" + currentUrlParams.toString()
    );
    var dataa = data;
    return dataa;

  }

  const defaultValues = {
    from: '',
    to: '',
    party: null
  };

  const clearFilter = () => {
    setSelectedRowKeys([])
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
    });
    reset(defaultValues)
    navigate(updateFilterUrl({}, 'ledger', 1), { replace: true })
  }


  useEffect(() => {

    const parsed = queryString.parse(location.search);

    if (location.search) {
      //setPage(parseInt(parsed.page))
    } else {
      setPage(1)
      setFilter(defaultValues)
    }



  }, [location]);

  const jvModal = useModal('journal_voucher');

  const addVoucher = (id, type) => {
    jvModal.show({ id: id, type: type, data: null }).then((res) => {
      queryClient.invalidateQueries([])
    });
  }

  useEffect(() => {


    const parsed = queryString.parse(location.search);

    if (parsed.page) {
      setPage(parseInt(parsed.page))
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          current: parseInt(parsed.page),
        },
      });
    } else {
      // setPage(1)
    }

    setFilter(parsed)




  }, []);







  const { data, error, isError, isLoading, isFetching } = useQuery(["ledger", location.search], () => fetchData(location.search), {
    keepPreviousData: true,
  });


  useEffect(() => {

    if (zstate) {
      const defaultValues1 = {
        from: filter.from,
        to: filter.to,
        party: filter.party && parseInt(filter.party),

      };
      reset(defaultValues1)
    }
  }, [filter]);


  useEffect(() => {
    if (data) {
      const parsed = queryString.parse(location.search);
      var setpage = 1;
      if (parsed.page) {
        setpage = parseInt(parsed.page);
      }
      if (parsed.page && parseInt(parsed.page) > 1 && data.items.length == 0) {
        let currentUrlParams = new URLSearchParams(window.location.search);

        setpage = Math.ceil(data.total / parseInt(tableParams.pagination.pageSize));
        setPage(setpage)

        currentUrlParams.set('page', setpage);

        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: data.total,
            current: setpage,
          },
        });

        navigate('/ledger?' + currentUrlParams.toString(), { replace: true })
      } else {
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: data.total,
            current: setpage,
          },
        });
      }
    }

  }, [data]);




  useEffect(() => {
    queryClient.invalidateQueries(['ledger']);
  }, [fy]);



  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };




  if (isLoading) {
    return <BgLoader />;
  }
  if (!data) {
    return (
      <BgLoader />
    )
  }

  if (data.status == 'error') {
    return (
      <PageError msg={data.msg} code={data.code} />
    )
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>
          Ledger
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Ledger" stacked={true}>

            {data.items &&
              <>
                {data.send_ledger == 1 &&
                  <>
                    <UiButton className="btn btn-outline-primary" onClick={() => generatePDF(data, 'print', 'ledger', showLoader)} title="Ledger" />
                    <UiButton className="btn btn-outline-primary ms-2" onClick={() => generatePDF(data, 'print', 'due_slip', showLoader)} title="Due Slip" />

                    <UiButton className="btn btn-outline-primary ms-2" onClick={() => generatePDF(data, 'send', 'ledger', showLoader)} title="Send" />


                    <CSVLink data={data.items} filename={"ledger.csv"} headers={headers} className={`btn btn-outline-primary d-inline-flex mx-2 ${data.items.length == 0 && 'disabled'}`} >Export</CSVLink>
                  </>
                }
              </>
            }


          </PageHeader>

          <div className="position-relative bg-white rounded mb-4">
            <form className="position-relative" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
              <div className="p-3 pb-0">
                <OverlayLoader visible={loader} />
                <div className="row">

                  <div className="col-md-2">

                    <Controller

                      name="from"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker
                          label="From"
                          onChange={onChange}
                          default_val={value}
                          message={errors.from?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />


                  </div>

                  <div className="col-md-2">

                    <Controller

                      name="to"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker
                          label="To"
                          onChange={onChange}
                          default_val={value}
                          message={errors.to?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />


                  </div>




                  <div className="col-md-3">
                    <Controller
                      name={`party`}
                      control={control}
                      render={({ field }) => (

                        <UiClientSelect
                          {...field}
                          parentClass="mb-1"
                          className=""
                          fetch_onload
                          message={errors.party?.message}
                          label="Party"

                        />

                      )}
                    />
                  </div>






                  <div className="col-md-2" style={{ paddingTop: '28px', minWidth: '200px' }}>
                    <div className="d-flex justify-content-end">

                      <UiButton type="" className="ms-2 btn-light" title="Clear" onClick={() => clearFilter()} />
                      <UiButton type="submit" className="ms-2 btn-primary" title="Filter" />
                    </div>

                  </div>
                </div>



              </div>
            </form>
            <div className="table-responsive" style={{ overflow: 'auto' }}>
              <div className="p-3" style={{ minWidth: '700px' }} id="printdiv">
                <div className="text-center">
                  <h1>{data.company}</h1>
                  <h3>{data.party}</h3>
                  <h2>Ledger</h2>
                  <p>{data.from} - {data.to}</p>
                </div>
                <p className="text-end">Opening Balance: Rs. {data.opening_bal}</p>
                <table className="table table-bordered">

                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>No.</th>
                      <th>Type</th>
                      <th>Particulars</th>

                      <th className="text-end">Debit (Rs.)</th>
                      <th className="text-end">Credit (Rs.)</th>
                      <th className="text-end">Balance (Rs.)</th>

                    </tr>
                  </thead>
                  <tbody>
                    {data.entries.map((item, index) => (
                      <tr key={index}>
                        <td>{item.date}</td>
                        <td>{item.num}</td>
                        <td>{item.type}</td>
                        <td>{item.type == 'Sales' ? <Link to={`/invoice/${item.id}`}>{item.account}</Link> : item.type == 'Purchase' ? <Link to={`/purchase/${item.id}`}>{item.account}</Link> : (item.type == 'Journal' || item.type == 'Receipt' || item.type == 'Payment') ? <a className="text-primary h-pointer" onClick={() => addVoucher(item.id, item.type)}>{item.account}</a> : item.account}
                          {item.items && item.items.map((itm, index) => (
                            <div className="d-flex justify-content-between" key={index}>
                              <small>{itm[0]}</small>
                              <small>{itm[1]}</small>
                            </div>
                          ))}

                        </td>

                        <td className="text-end">{item.debit}</td>
                        <td className="text-end">{item.credit}</td>
                        <td className="text-end">{item.balance}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>

                    <tr>
                      <td colSpan={4} className="text-end">Total</td>
                      <td className="text-end">{data.totals.debit}</td>
                      <td className="text-end">{data.totals.credit}</td>
                      <td></td>
                    </tr>
                  </tfoot>

                </table>
                <p className="text-end">Closing Balance: Rs. {data.totals.balance}</p>

              </div>
            </div>


          </div>
        </div>
      </div>
    </>
  );
}
